import React, {useState, useEffect} from "react";
import Card from "../../../Components/Card";
import ResourceTable, {IGenerateColumns} from "../../../Components/ResourceTable";
import {products} from "../../../Requests";

interface IProductsListProps {
    spedFiscalId?: number | null;
}

const Index: React.FC<IProductsListProps> = ({ spedFiscalId }) => {

    const [rechargeRequest, setRechargeRequest] = useState<number>(0);

    // Força recarga quando spedFiscalId mudar
    useEffect(() => {
        setRechargeRequest(prev => prev + 1);
    }, [spedFiscalId]);

    const generateColumns: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'code', type: 'number', headerName: 'CÓDIGO', width: 100},
            {field: 'barcode', type: 'number', headerName: 'CÓDIGO DE BARRAS', width: 150},
            {field: 'description', type: 'string', headerName: 'DESCRIÇÃO', width: 700},
            {field: 'unit', type: 'string', headerName: 'UNIDADE',  width: 100},
            {field: 'ncm', type: 'number', headerName: 'NCM', width: 150},
            {field: 'icms_tax', type: 'number', headerName: 'ALÍQUOTA ICMS', width: 200}
        ];

    }

    return (<>
        <Card
            titleDashboard='Listagem de Produtos do SPED Fiscal'
            icon='ProductionQuantityLimitsIcon'
            paperConfig={{minHeight: 704}}
            marginTop='0'
            lineDividerHeader={false}
        >
            <ResourceTable
                request={products}
                generateColumns={generateColumns}
                pageSizeOptions={[10]}
                getRowId={(row) => row?.identifier}
                minHeight={630}
                rechargeRequest={rechargeRequest}
                filterDefinitions={({ncm,barcode,descricao_completa,page,recordsPerPage}) => ({
                    ncm,
                    barcode,
                    descricao_completa,
                    sped_fiscal_id: spedFiscalId,
                    page,
                    recordsPerPage
                })}
            />
        </Card>
    </>);
}

export default Index;